<template>
  <div v-if="isLoading" class="h-screen flex items-center justify-center">
    <h1>Patensys is Loading</h1>
  </div>
  <div v-if="error" class="h-screen flex items-center justify-center">
    <h1>{{ error.message }}</h1>
  </div>
  <router-view v-if="!isLoading"></router-view>
</template>
<script>
import { auth } from "@/services/db.js";
import { setAuthToken } from "./services/backend-api";

export default {
  data() {
    return {
      error: false,
      isLoading: true,
    };
  },
  async mounted() {
    auth.onIdTokenChanged((user) => {
      if (user) {
        user.getIdToken().then(function(idToken) {
          setAuthToken(idToken);
        });
        this.isLoading = false;
      }
    });
    auth.onAuthStateChanged(async (user) => {
      // Patensys v2: simplified the code, moved previous logic to signin.vue and register.vue
      if (!user) {
        return;
      }
      if (user.emailVerified) {
        // 1. if user has verified email and logged in then set the auth token for backend api calls
        var idToken = user.getIdToken();
        setAuthToken(idToken);

        // 2. set the uid cookie
        this.$cookies.set("uid", user.uid, Infinity);

      }
      else {
        // if user has not verified email then redirect to register page
        this.$router.push('/register');
        return;
      }
    });

    if (auth.currentUser) {
      auth.currentUser.getIdToken().then(function(idToken) {
        setAuthToken(idToken);
      });
      this.isLoading = false;
    }
    else {
      this.isLoading = false;
      // Patensys v2: the following code is needed to make sure that: if the user comes from an invitation link, the user
      // continues with the accept_invite link; and if the user comes from an email sign-in link which also contains a redirect link to accept_invite (these are all
      // part of the accept invite process, please refer to accept_invite.vue for more details), then the user continues with the accept invite process;
      // for other cases, the user is redirected to the signin page.
      if ((!window.location.href.includes("accept_invite") && !window.location.href.includes("/register")) && !auth.isSignInWithEmailLink(window.location.href)) {
        if (window.location.href.includes("docketing") || window.location.href.includes("trademark-docketing")) {
          // if user tries to access docketing page before login, redirect to the url after login
          this.$router.push('/signin?redirect=' + window.location.pathname + window.location.search);
          return;
        }
        this.$router.push('/signin');
        return;
      }
    }
  },
};
</script>
